import { defineComponent as t, computed as c, createBlock as n, createCommentVNode as a, openBlock as m, resolveDynamicComponent as p } from "vue";
import { getLibraryIcon as s } from "./icons.js";
const d = /* @__PURE__ */ t({
  __name: "LibraryIcon",
  props: {
    src: {}
  },
  setup(o) {
    const r = o, e = c(() => s(r.src));
    return (u, i) => e.value ? (m(), n(p(e.value), { key: 0 })) : a("", !0);
  }
});
export {
  d as default
};
